import {
  REPLAY_RETENTION_ALLOWED_DAYS,
  type ReplayRetentionDays,
} from "../data/replay-retention";

/** Lock-Q12 chips for the account's Command Replay calendar. */
export function ReplayRetentionPicker({
  replayRetentionDays,
  onChange,
}: {
  replayRetentionDays: ReplayRetentionDays;
  onChange: (days: ReplayRetentionDays) => void;
}) {
  return (
    <fieldset className="tpl__fieldset ping-interval">
      <legend className="tpl__legend">Replay calendar</legend>
      <p className="setup__field-hint">
        How far back supervisors can choose a day in Command Replay. Older days are unavailable,
        not an empty tape.
      </p>
      <div className="shift-duration__presets" role="group" aria-label="Replay retention options">
        {REPLAY_RETENTION_ALLOWED_DAYS.map((days) => (
          <button
            key={days}
            type="button"
            className={`toggle-chip${replayRetentionDays === days ? " toggle-chip--on" : ""}`}
            aria-pressed={replayRetentionDays === days}
            onClick={() => onChange(days)}
          >
            {days} days
          </button>
        ))}
      </div>
    </fieldset>
  );
}
